export default __webpack_public_path__ + "static/media/d365Icon.41fb8933.png";